import request from '@/utils/request'

// 查询公告列表分页
export function pageNotice (query) {
  return request({
    url: '/system/notice/page',
    method: 'get',
    params: query
  })
}
// 查询公告列表
export function listNotice (query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}

// C-查询铃铛消息分页
export function messagePage (query) {
  return request({
    url: '/crm/push-message/page',
    method: 'get',
    params: query
  })
}

// C-查询铃铛消息未读数量
export function getNoReadNum (query) {
  return request({
    url: '/crm/push-message/getNoReadNum',
    method: 'get',
    params: query
  })
}

// 获取铃铛消息详情
export function messagedetail (query) {
  return request({
    url: '/crm/push-message/detail',
    method: 'get',
    params: query
  })
}



// 查询公告详细
export function getNotice (noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get'
  })
}

// 新增公告
export function addNotice (data) {
  return request({
    url: '/system/notice',
    method: 'post',
    data: data
  })
}

// 修改公告
export function updateNotice (data) {
  return request({
    url: '/system/notice',
    method: 'put',
    data: data
  })
}


// 删除消息
export function messagedelete (data) {
  return request({
    url: '/crm/push-message/delete',
    method: 'post',
    data: data
  })
}

// 标记消息已读
export function messageMarkRead (data) {
  return request({
    url: '/crm/push-message/markRead',
    method: 'post',
    data: data
  })
}

// 删除公告
export function delNotice (noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'delete'
  })
}
